import { model, attr } from 'services/model'
import * as yup from 'yup'

const validationSchema = yup.object().shape({
  title: yup
    .string()
    .typeError('Field title has wrong type')
    .default(null)
    .nullable()
})

const Badge = model(
  'badge',
  {
    title: attr('string')
  },
  validationSchema
)

export default Badge
